export class CharacteristicModel {
  CharacteristicId: number;
  Name: string;
  Description: string;
  UnitId: number;
  Value1: string;
  Value2: string;
  IsChecked:boolean;
  SpIdChar:SpIdCharModel;

  CreatedBy: number;
}

export class CharacteristicSearchModel {
  CharacteristicId: number;
  Name: string;
  PageNo: number;
  PageSize: number;
  PageIndex:number;
}

export class SpIdCharModel{
  SpidChariId:number;
  Spid:number;
  CharacteristicId:number;
  CreatedBy:number;
  CreatedDate:any;
}

export class LubricantTypesSearchModel{
  LubricantTypeId:number;
  Name:string;
  PageNo:number;
  PageSize:number;
  PageIndex:number; 
}

export class LubricantTypeModel{
  LubricantCharId:number;
  LubricantTypeId:number;
  Name:string;
  lstLubricantChars:CharacteristicModel[];
  lstCharIds:number[];
}
